import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import ThemeStore from "../stores/ThemeStore";
import SessionStore from "../stores/SessionStore";

interface LogoProps {
  className?: string;
  alt?: string;
  style?: React.CSSProperties;
}

const Logo: React.FC<LogoProps> = ({ 
  className = "logo", 
  alt = "BMP Logic", 
  style 
}) => {
  const [isDarkMode, setIsDarkMode] = useState(ThemeStore.getIsDarkMode());
  const navigate = useNavigate();

  useEffect(() => {
    const handleThemeChange = () => {
      setIsDarkMode(ThemeStore.getIsDarkMode());
    };

    ThemeStore.on("change", handleThemeChange);

    return () => {
      ThemeStore.removeListener("change", handleThemeChange);
    };
  }, []);

  const logoSrc = isDarkMode ? "/bmpLogicFullWhiteLogo.png" : "/bmpLogicFullLogo.png";

  const handleLogoClick = () => {
    const user = SessionStore.getUser();
    if (user) {
      if (SessionStore.isAdmin()) {
        navigate("/dashboard");
      } else {
        const tenantId = SessionStore.getTenantId();
        if (tenantId) {
          navigate(`/tenants/${tenantId}`);
        } else {
          navigate("/dashboard");
        }
      }
    }
  };

  return (
    <Button 
      type="text" 
      onClick={handleLogoClick}
      className="logo-button"
      style={{ 
        padding: 0, 
        height: 'auto', 
        border: 'none',
        background: 'transparent',
        boxShadow: 'none'
      }}
    >
      <img 
        className={className}
        alt={alt}
        src={logoSrc}
        style={style}
      />
    </Button>
  );
};

export default Logo;